import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Popup,
  I18n,
  TextInput,
  Heading,
  Icon,
  Button,
  Checkbox,
  Link,
  Preloader,
} from 'components';

import { EMAIL_REGEXP } from 'constants/common';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const getDefaultState = (props) => ({
  isDirty: false,
  isEmailValid: true,
  invoiceEmail: props.invoiceEmail || '',
  emailRegular: props.emailRegular || false,
});

class AccountGroupEditPopup extends PureComponent {
  constructor(props) {
    super(props);

    this.state = getDefaultState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(getDefaultState(props));
  }

  isSubmitDisabled() {
    const {
      isDirty,
      isEmailValid,
    } = this.state;

    return !isDirty || !isEmailValid;
  }

  saveGroup() {
    const {
      ben,
      ban,
      login,
      onSave,
    } = this.props;

    const {
      invoiceEmail,
      emailRegular,
    } = this.state;

    onSave({
      ben,
      ban,
      invoiceEmail,
      emailRegular,
      banLogin: login,
    });
  }

  render() {
    const {
      isOpened,
      onClose,
      ben,
      invoiceAddress,
      isAssociatedAccountUpdating,
    } = this.props;

    const {
      invoiceEmail,
      emailRegular,
      isEmailValid,
    } = this.state;

    if (!ben) {
      return null;
    }

    return (
      <Popup
        className={cx('popup')}
        opened={isOpened}
        onClose={() => !isAssociatedAccountUpdating && onClose()}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();

            if (!this.isSubmitDisabled() && !isAssociatedAccountUpdating) {
              this.saveGroup();
            }
          }}
        >
          <Heading
            level={3}
            className={cx('popupTitle')}
          >
            <Icon
              name="contract"
              className={cx('contractIcon')}
            />
            <I18n
              className={cx('contractTitle')}
              path="settings.numberManagement.associatedAccounts.groupTitle"
              vars={{ ben }}
            />
          </Heading>
          {isAssociatedAccountUpdating
            ? (
              <div className={cx('preloaderWrapper')}>
                <Preloader
                  className={cx('preloader')}
                  size="80"
                />
              </div>
            )
            : (
              <div>
                {invoiceAddress
                && (
                <div className={cx('inputWrapper')}>
                  <I18n
                    className={cx('inputLabel', 'addressLabel')}
                    path="settings.numberManagement.editPopup.invoiceAddressLabel"
                  />
                  <div className={cx('invoiceAddress')}>
                    {invoiceAddress}
                  </div>
                </div>
                )}
                <div className={cx('inputWrapper')}>
                  <Checkbox
                    className={cx('inputLabel', 'emailLabel')}
                    name={`email-regular-${ben}`}
                    checked={emailRegular}
                    handleChange={() => this.setState({
                      emailRegular: !emailRegular,
                      isDirty: true,
                    })}
                  >
                    <I18n path="settings.numberManagement.editPopup.invoiceEmailLabel" />
                  </Checkbox>
                  <div className={cx('emailWrapper')}>
                    <TextInput
                      className={cx('textInput', { fail: !isEmailValid })}
                      value={invoiceEmail}
                      onChange={(value) => this.setState({
                        invoiceEmail: value,
                        isDirty: true,
                        isEmailValid: value.match(EMAIL_REGEXP),
                      })}
                    />
                    {!isEmailValid
                    && (
                    <div className={cx('error')}>
                      <I18n path="settings.numberManagement.editPopup.invalidEmail" />
                    </div>
                    )}
                  </div>
                </div>
                <div className={cx('footer')}>
                  <Button
                    type="submit"
                    className={cx('saveButton')}
                    disabled={this.isSubmitDisabled()}
                  >
                    <I18n path="common.saveChanges" />
                  </Button>
                  <Link
                    onClick={onClose}
                  >
                    <I18n path="common.cancel" />
                  </Link>
                </div>
              </div>
            )}
        </form>
      </Popup>
    );
  }
}

AccountGroupEditPopup.propTypes = {
  isOpened: PropTypes.bool,
  isAssociatedAccountUpdating: PropTypes.bool,
  ben: PropTypes.number,
  ban: PropTypes.number,
  login: PropTypes.string,
  // emailRegular: PropTypes.bool,
  // invoiceEmail: PropTypes.string,
  invoiceAddress: PropTypes.string,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};

export default AccountGroupEditPopup;
